module.exports = __webpack_public_path__ + "media/images/logo-lucasistencia-white-2477ec9544585fe661f1ed94090650a4.png";